import { useStore, create } from "zustand";
import { LngLatBoundsLike, LngLatLike } from "mapbox-gl";

import { DEFAULT_MAX_BOUNDS } from "./types";

export interface TargetStore {
  viewport: LngLatBoundsLike | LngLatLike;
  setViewport: (viewport: TargetStore["viewport"]) => void;
}

const targetStore = create<TargetStore>()((set, get) => ({
  viewport: DEFAULT_MAX_BOUNDS,
  setViewport: (viewport: TargetStore["viewport"]) => set({ viewport }),
}));

export function useSubscribe() {
  return { subscribe: targetStore.subscribe };
}

function useTargetStore(): TargetStore;
function useTargetStore<T>(
  selector: (state: TargetStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useTargetStore<T>(
  selector?: (state: TargetStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(targetStore, selector!, equals);
}

export default useTargetStore;
